import accountSettingKo from './accountSetting.json';
import accountTerminationKo from './accountTermination.json';
import appTerminationKo from './appTermination.json';
import barcodeKo from './barcode.json';
import boardKo from './board.json';
import cartKo from './cart.json';
import commonKo from './common.json';
import couponKo from './coupon.json';
import customerServiceKo from './customerService.json';
import errorsKo from './errors.json';
import eventKo from './event.json';
import giftKo from './gift.json';
import inquiryKo from './inquiry.json';
import itemKo from './item.json';
import itemsKo from './items.json';
import linkKo from './link.json';
import mainKo from './main.json';
import noticeKo from './notice.json';
import notificationKo from './notification.json';
import orderKo from './order.json';
import orderLogKo from './orderLog.json';
import orderLogsKo from './orderLogs.json';
import orderReceiptKo from './orderReceipt.json';
import permissionKo from './permission.json';
import pointKo from './point.json';
import prepaidCardKo from './prepaidCard.json';
import shopDetailKo from './shopDetail.json';
import shopListKo from './shopList.json';
import shopLocationKo from './shopLocation.json';
import shopPrepareKo from './shopPrepare.json';
import signInKo from './signIn.json';
import signUpKo from './signUp.json';
import stampKo from './stamp.json';
import termDetailKo from './termDetail.json';

const ko = {
    accountSetting: accountSettingKo,
    accountTermination: accountTerminationKo,
    appTermination: appTerminationKo,
    barcode: barcodeKo,
    board: boardKo,
    cart: cartKo,
    common: commonKo,
    coupon: couponKo,
    stamp: stampKo,
    point: pointKo,
    prepaidCard: prepaidCardKo,
    customerService: customerServiceKo,
    errors: errorsKo,
    event: eventKo,
    gift: giftKo,
    inquiry: inquiryKo,
    item: itemKo,
    items: itemsKo,
    link: linkKo,
    main: mainKo,
    notice: noticeKo,
    notification: notificationKo,
    order: orderKo,
    orderLog: orderLogKo,
    orderLogs: orderLogsKo,
    orderReceipt: orderReceiptKo,
    permission: permissionKo,
    shopDetail: shopDetailKo,
    shopList: shopListKo,
    shopLocation: shopLocationKo,
    shopPrepare: shopPrepareKo,
    signIn: signInKo,
    signUp: signUpKo,
    termDetail: termDetailKo,
};

export default ko;
